/* eslint-disable */
import { useContext, useEffect, useState } from "react";

import { Outlet, useNavigate } from "react-router-dom";
import { jwtDecode, JwtPayload } from "jwt-decode";

import { Layout } from "../../layout/Layout";
import { useAppDispatch, useAppSelector } from "../../store/store";
import { setBankName, setBrand } from "../../store/appSlice";
import { axaDiProductUniqueCode, axaPpiProductUniqueCode, bankNames } from "../../common/constants";
import { useGetProductsQuery } from "../../store/policiesSlice";
import { ProductContext } from "../../context/ProductContext";
import { logout } from "../../store/authSlice";
import { LocalizationContext } from "../../App";

export const ProtectedRoute = () => {
  const l10n = useContext(LocalizationContext);
  const { isUserLogged, token } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { data: products, isLoading: isLoadingProducts } = useGetProductsQuery(undefined, {
    skip: !isUserLogged,
  });
  const [productContext, setProductContext] = useState<ProductContext | undefined>(undefined);

  useEffect(() => {
    if (isUserLogged && !isLoadingProducts) {
      if (products) {
        const diProductId = products?.find(
          (prod) => prod.productUniqueCode === axaDiProductUniqueCode
        )?.id;
        const ppiProductId = products?.find(
          (prod) => prod.productUniqueCode === axaPpiProductUniqueCode
        )?.id;

        if (diProductId && ppiProductId) {
          setProductContext({
            di: diProductId,
            ppi: ppiProductId,
            productIdToTypeKeyDict: {
              [diProductId]: "DI",
              [ppiProductId]: "PPI",
            },
          });
        }
      } else {
        dispatch(logout());
      }
    }
  }, [isUserLogged, isLoadingProducts, products]);

  useEffect(() => {
    if (!token || !isUserLogged) {
      navigate("/login");
    } else {
      const demo = localStorage.getItem("demo");
      const demoMode = demo === "1";
      if (!demoMode) { // Restore brand from user token if not demo mode
        const decodedToken = jwtDecode<JwtPayload & { tenant_id: string }>(token);
        const tenantId = Number(decodedToken.tenant_id);
        dispatch(setBrand(tenantId));
        dispatch(setBankName(bankNames[tenantId]));
      }
    }
  }, [isUserLogged, navigate]);

  if (isLoadingProducts || !productContext) {
    return (
      <Layout>
        <div className="loading-screen flex flex-col justify-center items-center">
          <div className="text-body text-xl">{l10n.common.loading}</div>
        </div>
      </Layout>
    );
  }

  return (
    <ProductContext.Provider value={productContext}>
      <Layout>
        <Outlet />
      </Layout>
    </ProductContext.Provider>
  );
};
